import { withStyles } from '@material-ui/core';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

export const PasswordInfo = withStyles(({ palette, spacing }) => ({
  root: {
    color: palette.grey[300],
    marginTop: spacing(1.5),
    padding: spacing(0, 0.5),
  },
}))(FsBodySmall);
